export default __webpack_public_path__ + "73a9df3eecacf190911c70dfa69c128b.png";